export function formatCalibrationNumber(value, digits = 1) {
  if (value == null || value === "") return null;
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  return number.toLocaleString("pt-BR", {
    maximumFractionDigits: digits,
    minimumFractionDigits: number === Math.round(number) ? 0 : Math.min(digits, 1),
  });
}

export function formatCalibrationRate(value, unit, digits = 1) {
  const formatted = formatCalibrationNumber(value, digits);
  if (!formatted) return "—";
  return unit ? `${formatted} ${unit}` : formatted;
}

function readGroup(payload, keys) {
  return {
    hectaresPerHour: payload[keys.hectaresPerHour],
    hectares: payload[keys.hectares],
    fertilizerKgHa: payload[keys.fertilizerKgHa],
    seedThousand: payload[keys.seedThousand],
    seedPerMeter: payload[keys.seedPerMeter],
    inoculantLHa: payload[keys.inoculantLHa],
  };
}

function groupHasValues(group) {
  if (!group) return false;
  return [
    group.hectaresPerHour,
    group.hectares,
    group.fertilizerKgHa,
    group.seedThousand,
    group.seedPerMeter,
    group.inoculantLHa,
  ].some((value) => value != null && value !== "");
}

export function calibrationAveragesFromPayload(payload) {
  if (!payload || typeof payload !== "object") return null;

  const last3 = readGroup(payload, {
    hectaresPerHour: "media_ultimas_3_ha_h",
    hectares: "media_ultimas_3_hectares",
    fertilizerKgHa: "media_ultimas_3_adubo_kg_ha",
    seedThousand: "media_ultimas_3_semente_mil_ha",
    seedPerMeter: "media_ultimas_3_sementes_m",
    inoculantLHa: "media_ultimas_3_inoculante_l_ha",
  });
  const total = readGroup(payload, {
    hectaresPerHour: "media_total_ha_h",
    hectares: "media_total_hectares",
    fertilizerKgHa: "media_total_adubo_kg_ha",
    seedThousand: "media_total_semente_mil_ha",
    seedPerMeter: "media_total_sementes_m",
    inoculantLHa: "media_total_inoculante_l_ha",
  });
  const current = {
    hectaresPerHour: payload.media_esta_abastecida_ha_h,
    hectares: payload.hectares_plantados || payload.hectares_feitos,
    fertilizerKgHa: payload.taxa_aplicada_adubo_kg_ha,
    seedThousand:
      payload.taxa_aplicada_semente_mil_ha || payload.taxa_aplicada_semente,
    seedPerMeter: payload.sementes_por_metro_aplicadas,
    inoculantLHa: payload.taxa_aplicada_inoculante_l_ha,
  };

  if (!groupHasValues(last3) && !groupHasValues(total) && !groupHasValues(current)) {
    return null;
  }

  return {
    last3Count: Number(payload.abastecidas_ultimas_3_contagem) || 0,
    totalCount: Number(payload.abastecidas_total_contagem) || 0,
    current,
    last3,
    total,
    hasLast3: groupHasValues(last3),
    hasTotal: groupHasValues(total),
    hasCurrent: groupHasValues(current),
  };
}

export const CALIBRATION_AVERAGE_KEYS = [
  "abastecidas_ultimas_3_contagem",
  "abastecidas_total_contagem",
  "media_ultimas_3_ha_h",
  "media_total_ha_h",
  "media_ultimas_3_hectares",
  "media_total_hectares",
  "media_ultimas_3_adubo_kg_ha",
  "media_total_adubo_kg_ha",
  "media_ultimas_3_semente_mil_ha",
  "media_total_semente_mil_ha",
  "media_ultimas_3_sementes_m",
  "media_total_sementes_m",
  "media_ultimas_3_inoculante_l_ha",
  "media_total_inoculante_l_ha",
];

export const CALIBRATION_PLATFORM_DEMO_PAYLOAD = {
  tipo_evento: "CHECK_CALIBRAGEM",
  informacoes_produto: "Soja 58I60 RSF IPRO · MAP + inoculante",
  ordem_servico_id: 1842,
  hectares_painel_inicial: 500,
  hectares_painel: 550,
  hectares_plantados: 10,
  adubo_kg: 2000,
  semente_quantidade: 2,
  semente_unidade: "bags",
  inoculante_l: 20,
  taxa_alvo_adubo_kg_ha: 280,
  taxa_aplicada_adubo_kg_ha: 200,
  taxa_alvo_semente: 200,
  taxa_aplicada_semente_mil_ha: 190,
  sementes_por_metro_aplicadas: 8.6,
  taxa_alvo_inoculante_l_ha: 2,
  taxa_aplicada_inoculante_l_ha: 2,
  abastecidas_ultimas_3_contagem: 3,
  abastecidas_total_contagem: 4,
  media_ultimas_3_ha_h: 5,
  media_total_ha_h: 4.8,
  media_ultimas_3_hectares: 40,
  media_total_hectares: 50,
  media_ultimas_3_adubo_kg_ha: 250,
  media_total_adubo_kg_ha: 280,
  media_ultimas_3_semente_mil_ha: 202.5,
  media_total_semente_mil_ha: 198,
  media_ultimas_3_sementes_m: 9.1,
  media_total_sementes_m: 8.9,
  media_ultimas_3_inoculante_l_ha: 2,
  media_total_inoculante_l_ha: 2,
  fora_da_tolerancia: false,
};
